import React from 'react';
import Card from 'sulu-admin-bundle/components/Card';

class Hint extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {title, infoText} = this.props.schemaOptions.data;

        return (
            <>
                <Card>
                    {title && <h3 style={{marginBottom: 0}}>{title}</h3>}
                    {infoText && <p style={{marginBottom: 0}}>{infoText}</p>}
                </Card>
            </>
        );
    }
}

export default Hint;